import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';

import ProgressBar from './ProgressBar';
import Star from '../StarRating/Star';

export default class RatingStatistics extends Component {
  renderBars = () => {
    const { ratingDistribution, renderReviews, totalReviews } = this.props;
    let row = [];
    for (let i = 5; i > 0; i--) {
      row.push(
        <div
          className="o-grid  o-grid--gutters  o-grid--center  u-margin-bot-small"
          key={i}
          onClick={() => ratingDistribution[i] && renderReviews(i)}
        >
          <div className="o-grid__item  o-grid__item--shrink">
            {i}
            <Star
              editable={false}
              fillType="full"
              index={i}
              key={`star-${i}`}
            />
          </div>
          <ProgressBar
            index={i}
            ratingDistribution={ratingDistribution}
            totalReviews={totalReviews}
          />
          <div className="o-grid__item  o-grid__item--shrink  u-text-right">
            <span>{ratingDistribution[i] ? ratingDistribution[i] : 0}</span>
          </div>
        </div>
      );
    }
    return row;
  };
  render() {
    return <Fragment>{this.renderBars()}</Fragment>
  }
}

RatingStatistics.propTypes = {
  ratingDistribution: PropTypes.shape({
    /* key value pairs */
  }),
  renderReviews: PropTypes.func.isRequired,
  totalReviews: PropTypes.number.isRequired,
};
